export function check(current, authority) {
  const arr = authority || [];
  return current.some(item => arr.includes(item));
}
